import React from 'react';
import { PencilIcon } from 'components/icons';
import { to } from 'acl';
import { AuthContext } from 'auth';
import { Button } from '@odin-labs/components';
import { Link } from 'react-router-dom';

export function EditJobsiteSettingsButton({
  baseRoute,
  jobsiteId,
  className = 'odin-text-odin-primary hover:odin-text-odin-two-tone',
}: {
  baseRoute: string;
  jobsiteId?: string;
  className?: string;
}): React.ReactElement {
  const { currentUser: user } = React.useContext(AuthContext);

  return jobsiteId && user.isAllowed(to.editJobsiteConfiguration, jobsiteId) ? (
    <Button
      theme="naked"
      size="sm"
      aria-label="Edit site info"
      as={Link}
      to={`${baseRoute}/settings`}
      className={className}
    >
      <PencilIcon className="odin-h-4 odin-w-4" />
    </Button>
  ) : null;
}
